export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6355.2cac95d0.jpg";